export const ERROR = {
  REQUIRED: 'Required',
  TOO_SHORT: 'Too short',
  TOO_LONG: 'Too long',
  TOO_WEAK: 'Too weak',
  INVALID_FORMAT: 'Invalid format',
  INVALID_VALUE: 'Invalid value',
};

export const OUTPUT_LINK = 'https://www.ynet.co.il/';

export const SHARE_CONSTANTS = {
  WHATSAPP: 'whatsApp',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
};
